import React from "react";
import { Route, Navigate } from "react-router-dom";
import VendorDashboard from "../components/Vendor/Dashboard/VendorDashboard";
import ManageDevices from "../components/Vendor/Dashboard/ManageDevices";
import ManagePayout from "../components/Vendor/Dashboard/ManagePayout";
import ManageProfile from "../components/Vendor/Dashboard/ManageProfile";
import VendorDeviceDashboardWrapper from "../components/Vendor/Device/VendorDeviceDashboardWrapper";
import VendorRegisterDevice from "../components/Vendor/Device/VendorRegisterDevice";
import VendorRequestsDashboard from "../components/Vendor/Device/VendorRequestsDashboard";

// The dashboard used to be declared as:
//
//   <Route path="/vendor-dashboard/*" element={<VendorDashboard />}>
//       <Route path="devices" element={<VendorDashboard section="devices" />} />
//       ...
//       <Route path="device/:deviceId" element={<VendorDeviceDashboardWrapper />} />
//   </Route>
//
// Three things wrong with that, and together they are why "Manage" appeared to
// do nothing:
//
//   - A trailing `/*` on a route that also has children. The splat is meant to
//     mark a leaf that hands the rest of the path to a nested <Routes>; giving
//     it children as well makes the match ambiguous, and it is what let a
//     relative <Link> inside the dashboard resolve against the whole current
//     URL instead of against /vendor-dashboard. That is the compounding
//     /device/3/device/3/device/3.
//   - Each child rendered VendorDashboard *again*, inside the parent
//     VendorDashboard's own <Outlet/> — a dashboard nested in itself. The
//     `section` prop it was passed was never read; the component held the
//     section in local state.
//   - Because the section was local state and not the URL, arriving at
//     /vendor-dashboard/device/3 left the device list rendered above the
//     device page, so the screen looked unchanged.
//
// The sections are now ordinary child routes and the dashboard is the layout
// around them, which is the shape the rest of this file already assumed.

export const vendorRoutes = (
    <>
        <Route path="/vendor-dashboard" element={<VendorDashboard />}>
            {/* Canonicalise the bare path so the URL and the selected tab
                never disagree -- /vendor-dashboard on its own would otherwise
                render the screens list with no tab marked current. */}
            <Route index element={<Navigate to="devices" replace />} />
            <Route path="devices" element={<ManageDevices />} />
            <Route path="payout" element={<ManagePayout />} />
            <Route path="profile" element={<ManageProfile />} />
            <Route path="device/:deviceId" element={<VendorDeviceDashboardWrapper />} />
        </Route>
        <Route path="/vendor/register-device" element={<VendorRegisterDevice />} />
        <Route path="/vendor-profile" element={<ManageProfile />} />
        <Route path="/vendor/requests" element={<VendorRequestsDashboard />} />
    </>
);
